var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 27.08V28a10 10 0 11-5.93-9.14M38 20L28 30.01l-3-3",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#ECFDF3",
    strokeWidth: 8
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNCIgeT0iNCIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iMjQiIGZpbGw9IiNEMUZBREYiLz4KPHBhdGggZD0iTTM4IDI3LjA4MDFWMjguMDAwMUMzNy45OTg4IDMwLjE1NjUgMzcuMzAwNSAzMi4yNTQ4IDM2LjAwOTMgMzMuOTgxOUMzNC43MTgyIDM1LjcwOTEgMzIuOTAzMyAzNi45NzI2IDMwLjgzNTQgMzcuNTg0QzI4Ljc2NzQgMzguMTk1NCAyNi41NTczIDM4LjEyMiAyNC41MzQ1IDM3LjM3NDdDMjIuNTExNyAzNi42Mjc0IDIwLjc4NDcgMzUuMjQ2MiAxOS42MTEgMzMuNDM3MkMxOC40MzczIDMxLjYyODEgMTcuODc5OCAyOS40ODgyIDE4LjAyMTcgMjcuMzM2NEMxOC4xNjM2IDI1LjE4NDcgMTguOTk3MiAyMy4xMzY0IDIwLjM5ODMgMjEuNDk3MkMyMS43OTk0IDE5Ljg1NzkgMjMuNjkyOCAxOC43MTU1IDI1Ljc5NjIgMTguMjQwM0MyNy44OTk2IDE3Ljc2NSAzMC4xMDAzIDE3Ljk4MjQgMzIuMDcgMTguODYwMU0zOCAyMC4wMDAxTDI4IDMwLjAxMDFMMjUgMjcuMDEwMSIgc3Ryb2tlPSIjMDM5ODU1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cmVjdCB4PSI0IiB5PSI0IiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHJ4PSIyNCIgc3Ryb2tlPSIjRUNGREYzIiBzdHJva2Utd2lkdGg9IjgiLz4KPC9zdmc+Cg==";
export { SvgDoneIcon as ReactComponent };